
import { Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface OfferDetailsCardProps {
  refundApproved?: boolean;
  partialRefundOffered?: boolean;
  amount?: number;
  customInstructions?: string;
}

const OfferDetailsCard = ({ refundApproved, partialRefundOffered, amount, customInstructions }: OfferDetailsCardProps) => {
  if (!refundApproved && !partialRefundOffered && !customInstructions) return null;

  return (
    <Card className="mb-4 bg-muted/50">
      <CardContent className="pt-4">
        <div className="flex items-start gap-4">
          {refundApproved && (
            <>
              <div className="rounded-full p-2 bg-green-50">
                <Check className="h-4 w-4 text-green-600" />
              </div>
              <div className="space-y-1">
                <h4 className="text-sm font-medium">Full Refund Approved</h4>
                <div className="text-sm text-muted-foreground">
                  <p>Your refund request for ${amount} has been approved.</p>
                </div>
              </div>
            </>
          )}
          
          {partialRefundOffered && (
            <>
              <div className="rounded-full p-2 bg-amber-50">
                <Check className="h-4 w-4 text-amber-600" />
              </div>
              <div className="space-y-1">
                <h4 className="text-sm font-medium">Partial Refund Offered</h4>
                <div className="text-sm text-muted-foreground">
                  <p>A partial refund has been offered. Review the message for details.</p>
                </div>
              </div>
            </>
          )}
          
          {!refundApproved && !partialRefundOffered && customInstructions && (
            <div className="space-y-1 w-full">
              <h4 className="text-sm font-medium">Custom Instructions Applied</h4>
              <div className="text-sm text-muted-foreground">
                <p>{customInstructions}</p>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default OfferDetailsCard;
